import DOMPurify from "dompurify";

/** Sanitizes rich text supplied by merchant-managed API content. */
export const sanitizeHtml = (value: unknown): string =>
  DOMPurify.sanitize(String(value || ""), {
    USE_PROFILES: { html: true },
  });
